import { render, staticRenderFns } from "./ActividadesView.vue?vue&type=template&id=2ca37b9a&scoped=true&"
import script from "./ActividadesView.vue?vue&type=script&lang=ts&"
export * from "./ActividadesView.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadesView.vue?vue&type=style&index=0&id=2ca37b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca37b9a",
  null
  
)

export default component.exports